function findPlanet(chartData, name) {
  return chartData?.planets?.find((planet) => planet.name === name) ?? null;
}

function findAngle(chartData, name) {
  return chartData?.angles?.find((angle) => angle.name === name) ?? null;
}

/**
 * Build a chart signature subtitle for preview headers.
 * Omits rising sign when birth time is unknown (noon fallback).
 */
export function buildChartSignature(chartData, { birthTimeAccuracy = 'known' } = {}) {
  if (!chartData) {
    return '';
  }

  const parts = [];
  const sun = findPlanet(chartData, 'Sun');
  const moon = findPlanet(chartData, 'Moon');

  if (sun?.sign) {
    parts.push(`Sun in ${sun.sign}`);
  }
  if (moon?.sign) {
    parts.push(`Moon in ${moon.sign}`);
  }

  if (birthTimeAccuracy !== 'unknown') {
    const asc = findAngle(chartData, 'ASC');
    if (asc?.sign) {
      parts.push(`${asc.sign} Rising`);
    }
  } else {
    const saturn = findPlanet(chartData, 'Saturn');
    if (saturn?.sign) {
      parts.push(`${saturn.name} in ${saturn.sign}`);
    }
  }

  return parts.join(' · ');
}
